export default {
  skills:[],
  errorSkillsAPI:"",
}